// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"e76b650d73896fe55b86","715":"4356b53220309b470f16"}[chunkId] + ".2133.js";
};